module.exports = __webpack_public_path__ + "static/arrow-down-376c6280e251df091350396c6ad73be9.png";